import { ButtonProps, makeStyles } from "@material-ui/core";

import { ButtonBase } from "./ButtonBase";

const useStyles = makeStyles({
    root: {
        backgroundColor: "#F44336",
        color: "#FFFFFF",
        border: "1px solid #F44336",
        boxShadow: "none",

        "&:hover": {
            backgroundColor: "#d0180b",
            border: "1px solid #d0180b",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
        },
        
        "&:disabled": {
            backgroundColor: "#818181",
            color: "#FFFFFF",
        },
    },
});

export const RedButton = (props: ButtonProps) => {
    const classes = useStyles();

    const { className, ...otherProps } = props;

    return (
        <ButtonBase
            className={className ? `${classes.root} ${className}` : classes.root}
            variant="contained"
            {...otherProps}
        />
    );
};
